export const interventionTemplate = {
  add: {
    label: "Ajouter un gabarit d'intervention",
  },
  category: {
    compliance: "Conformité",
    defect: "Défaillance",
    identification: "Identification",
  },
  create: {
    label: "Créer un gabarit d'intervention",
  },
  createSection: "Créer une nouvelle section",
  createSubSection: "Créer une nouvelle sous-section",
  editSection: "Modifier la section",
  editSubSection: "Modifier la sous-section",
  dataset: {
    create: {
      label: "Créer un gabarit de dataset",
    },
  },
  delete: {
    label: "Supprimer le gabarit d'intervention",
  },
  description: {
    label: "Description",
  },
  dynamic: {
    label: "Dynamique",
  },
  informations: {
    label: "Informations sur le gabarit d'intervention",
  },
  name: {
    label: "Nom",
  },
  referenceId: "Identifiant de référence",
  type: {
    label: "Type",
  },
  version: {
    currentVersion: "Version actuelle",
    latest: "(dernière version)",
    otherRevisions: "Autres révisions",
    revisionPlural: "Révisions",
    revisionOf: "Révision de",
    createEditableRevision: {
      button: "Créer une révision modifiable",
    },
    latestRevision: {
      button: "Aller à la dernière révision",
    },
  },
  form: {
    addForm: "Ajouter un formulaire d'intervention",
    assetTypeFilter: {
      label: "Filtres de types d'actifs",
    },
    assetTypes: {
      allTypes: {
        label: "Tous les types",
      },
      label: "Types d'actif",
    },
    category: {
      label: "Catégorie",
    },
    edit: {
      label: "Editer le gabarit d'intervention",
    },
    name: {
      label: "Nom",
    },
    description: {
      label: "Description",
    },
    type: {
      label: "Type d'intervention",
    },
    section: {
      remove: {
        label: "Enlever la section du gabarit d'intervention",
      },
    },
    state: {
      label: "État",
    },
    usedInIntervention: {
      label: "Utilisé en intervention",
    },
    flags: {
      title: "Répétitions",
      dynamic: "Permettre à l'utilisateur d'ajouter des éléments à la liste.",
      loopOnChildren: "Boucle sur les enfants",
      displayForCurrentAsset: "Affiche pour l'actif actuel",
    },
    organizations: {
      label: "Organisations",
    },
    modules: {
      label: "Modules",
    },
  },
  tableOfContents: "Table des matières",
  error: {
    fileNamesTooLong: "Le nom des fichiers suivant sont trop long",
    model: "Impossible de sauvegarder le gabarit d'intervention.",
  },
};
